var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurityTestingGraphicRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 433.89 379.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4371b7;\n      }\n\n      .cls-2 {\n        fill: #1160ad;\n      }\n\n      .cls-3 {\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n\n      .cls-3, .cls-4, .cls-5 {\n        fill: none;\n      }\n\n      .cls-3, .cls-5 {\n        stroke: #0072b8;\n      }\n\n      .cls-6 {\n        fill: #3b89c9;\n      }\n\n      .cls-7 {\n        fill: #2c317f;\n      }\n\n      .cls-8 {\n        fill: #2c3380;\n      }\n\n      .cls-9 {\n        fill: #0e50a2;\n      }\n\n      .cls-10 {\n        fill: #3fbaeb;\n      }\n\n      .cls-5 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.5px;\n      }\n\n      .cls-11 {\n        fill: #4657a6;\n      }\n\n      .cls-12 {\n        fill: #11499e;\n      }\n\n      .cls-13 {\n        fill: #42b3e6;\n      }\n\n      .cls-14 {\n        fill: #2d3390;\n      }\n\n      .cls-15 {\n        fill: #0072b8;\n      }\n\n      .cls-16 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-17 {\n        fill: #323f98;\n      }\n\n      .cls-18 {\n        fill: #2c317d;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 8.77,
    y: -18.06,
    width: 472.34,
    height: 472.34
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 193.09,
    cy: 12.27,
    r: 3.93
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "227.74 99.62 228.21 33.97 193.65 13.1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "266.63 238.17 363.93 294.23 416.68 283.52"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 416.26,
    cy: 284.08,
    r: 3.93
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 402.88,
    cy: 306.61,
    r: 3.93
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "248.68 248.57 362.83 314.46 403.29 306.51"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 310.4,
    y1: 284.23,
    x2: 310.28,
    y2: 344.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 310.4,
    y1: 303.2,
    x2: 284.11,
    y2: 319.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 310.24,
    y1: 323.98,
    x2: 292.92,
    y2: 334.69
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 292.94,
    cy: 334.9,
    r: 3.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 309.83,
    cy: 344.82,
    r: 3.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 284.13,
    cy: 319.47,
    r: 3.93
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "227.35 265.81 252.22 280.61 251.59 320.6 216.33 341.7 216.95 361.22"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 216.5,
    cy: 361.27,
    r: 3.93
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 46.66,
    cy: 302.99,
    r: 3.93
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "195.31 257.5 134.37 292.93 81.79 282.54 45.89 303"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 203.67,
    cy: 313.33,
    r: 3.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 150.77,
    cy: 364.02,
    r: 3.93
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "212.78 267.38 168.38 292.89 169.01 353.66 150.75 364.05"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "187.59 282.5 203.34 292.89 203.57 313.28"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 42.85,
    cy: 264.1,
    r: 3.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 113.94,
    cy: 263.4,
    r: 3.93
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "142.76 226.64 96.23 253.92 61.36 254.08 42.78 264.47"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "113.71 243.06 131.19 253.21 113.71 263.6"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "309.61 171.1 360.62 141.34 361.1 100.72 397 79.94"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 396.66,
    cy: 79.3,
    r: 3.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 413.35,
    cy: 140.21,
    r: 3.93
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "335.08 156.22 360.62 171.57 414 139.93"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "168.07 159.73 92.73 116.59 109.26 107.3 62.34 79.9"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 61.55,
    cy: 79.22,
    r: 3.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 80.44,
    cy: 48.52,
    r: 3.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 79.5,
    y1: 90.37,
    x2: 80.21,
    y2: 49.28
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "125.44 135.24 159.45 115.64 188.93 132.84"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 12.7,
    cy: 241.16,
    r: 3.93
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "107.02 206.8 64.74 231.36 46.32 221.37 12.31 241.21"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 36.02,
    cy: 154.66,
    r: 3.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 17.93,
    cy: 123.82,
    r: 3.93
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "134.14 172.05 70.77 133.63 36.13 154.41"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 53.29,
    y1: 144.18,
    x2: 17.86,
    y2: 124.18
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "293.28 224.44 307.41 232.35 360.31 201.17 412.9 231.72"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 413.11,
    cy: 231.65,
    r: 3.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 422.17,
    cy: 210.16,
    r: 3.93
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "384.24 214.56 406.76 200.27 422.34 209.91"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 337.54,
    cy: 15.22,
    r: 3.93
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "307.09 73.01 325.36 83.72 291.66 103.87"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "274.34 91.91 337.17 55.54 298.91 34.28 338.11 15.39"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M303.87,220.33v-9.08h0c.01,1.28-.6,2.56-1.85,3.3l-78.71,46.8c-1.92,1.14-4.31,1.16-6.25.04l-114.49-66.24c-1.27-.74-1.9-2.03-1.89-3.32h-.02s.11,9.57.11,9.57c-.08,1.35.54,2.74,1.88,3.51l113.88,65.89c2.31,1.34,5.16,1.32,7.45-.04l78.11-46.44c1.48-.88,2.06-2.5,1.78-3.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M102.56,195.16l114.49,66.24c1.94,1.12,4.33,1.11,6.25-.04l78.71-46.8c1.25-.74,1.87-2.03,1.85-3.3-.01-1.26-.64-2.52-1.89-3.25l-114.83-66.51c-1.18-.68-2.64-.68-3.81,0l-80.78,47.08c-1.25.73-1.87,1.98-1.88,3.25-.01,1.29.62,2.58,1.89,3.32Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "183.02 149.74 174.85 154.73 183.02 159.72 191.49 154.58 183.02 149.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "192.92 155.41 184.76 160.4 192.92 165.39 201.39 160.25 192.92 155.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "202.83 161.08 194.66 166.07 202.83 171.06 211.29 165.92 202.83 161.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "212.73 166.75 204.56 171.74 212.73 176.73 221.2 171.59 212.73 166.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "222.63 172.42 214.47 177.41 222.63 182.4 231.1 177.26 222.63 172.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "232.54 178.09 224.37 183.08 232.54 188.07 241 182.93 232.54 178.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "242.44 183.76 234.28 188.75 242.44 193.74 250.91 188.6 242.44 183.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "252.34 189.43 244.18 194.42 252.34 199.41 260.81 194.27 252.34 189.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "262.25 195.1 254.08 200.09 262.25 205.08 270.71 199.94 262.25 195.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "272.15 200.77 263.99 205.76 278.03 213.96 284.62 207.91 272.15 200.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "282.05 206.44 273.89 211.43 282.05 216.42 290.52 211.28 282.05 206.44"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "173.34 155.49 165.18 160.48 173.34 165.46 181.81 160.32 173.34 155.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "183.24 161.16 175.08 166.15 183.24 171.13 191.71 165.99 183.24 161.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "193.15 166.83 184.98 171.82 193.15 176.81 201.62 171.66 193.15 166.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "203.05 172.5 194.89 177.49 203.05 182.48 211.52 177.33 203.05 172.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "212.96 178.17 204.79 183.16 212.96 188.15 221.42 183 212.96 178.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "222.86 183.84 214.69 188.83 222.86 193.82 231.33 188.67 222.86 183.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "232.76 189.51 224.6 194.5 232.76 199.49 241.23 194.34 232.76 189.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "242.67 195.18 234.5 200.17 242.67 205.16 251.13 200.01 242.67 195.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "252.57 200.85 244.41 205.84 252.57 210.83 261.04 205.68 252.57 200.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "262.47 206.52 254.31 211.51 262.47 216.5 270.94 211.35 262.47 206.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "272.38 212.19 264.21 217.18 272.38 222.17 280.85 217.02 272.38 212.19"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "163.66 161.23 155.5 166.22 169.87 174.65 175.16 167.83 163.66 161.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "173.57 166.9 165.4 171.89 173.57 176.88 182.03 171.74 173.57 166.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "183.47 172.57 175.31 177.56 183.47 182.55 191.94 177.41 183.47 172.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "193.38 178.24 185.21 183.23 193.38 188.22 201.84 183.08 193.38 178.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "203.28 183.91 195.11 188.9 203.28 193.89 211.75 188.75 203.28 183.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "213.18 189.58 205.02 194.57 213.18 199.56 221.65 194.42 213.18 189.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "223.09 195.25 214.92 200.24 223.09 205.23 231.55 200.09 223.09 195.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "232.99 200.92 224.82 205.91 232.99 210.9 241.46 205.76 232.99 200.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "242.89 206.59 234.73 211.58 242.89 216.57 251.36 211.43 242.89 206.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "252.8 212.26 244.63 217.25 252.8 222.24 261.26 217.1 252.8 212.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "262.7 217.93 254.54 222.92 262.7 227.91 271.17 222.77 262.7 217.93"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "153.99 166.98 145.82 171.97 159.4 179.82 167.04 174.46 153.99 166.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "163.89 172.65 155.73 177.64 163.89 182.63 172.36 177.49 163.89 172.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "173.79 178.32 165.63 183.31 173.79 188.3 182.26 183.16 173.79 178.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "183.7 183.99 175.53 188.98 183.7 193.97 192.17 188.83 183.7 183.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "193.6 189.66 185.44 194.65 193.6 199.64 202.07 194.5 193.6 189.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "203.51 195.33 195.34 200.32 203.51 205.31 211.97 200.17 203.51 195.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "213.41 201 205.24 205.99 213.41 210.98 221.88 205.84 213.41 201"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "223.31 206.67 215.15 211.66 223.31 216.65 231.78 211.51 223.31 206.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "233.22 212.34 225.05 217.33 233.22 222.32 241.68 217.18 233.22 212.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "243.12 218.01 234.96 223 243.12 227.99 251.59 222.85 243.12 218.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "253.02 223.68 244.86 228.67 253.02 233.66 261.49 228.52 253.02 223.68"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "144.31 172.72 136.15 177.71 144.31 182.7 152.78 177.56 144.31 172.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "154.21 178.39 146.05 183.38 154.21 188.37 162.68 183.23 154.21 178.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "164.12 184.06 155.95 189.05 164.12 194.04 172.58 188.9 164.12 184.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "174.02 189.73 165.86 194.72 179 202.28 186.43 196.85 174.02 189.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "183.93 195.4 175.76 200.39 189.6 208.39 196.74 202.77 183.93 195.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "193.83 201.07 185.66 206.06 199.75 214.28 206.67 208.42 193.83 201.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "203.73 206.74 195.57 211.73 203.73 216.72 212.2 211.58 203.73 206.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "213.64 212.41 205.47 217.4 213.64 222.39 222.1 217.25 213.64 212.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "223.54 218.08 215.37 223.07 223.54 228.06 232.01 222.92 223.54 218.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "233.44 223.75 225.28 228.74 239.45 237.01 246.4 231.17 233.44 223.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "243.35 229.42 235.18 234.41 243.35 239.4 251.81 234.26 243.35 229.42"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "163.02 196.42 142.77 208.5 189.08 235.15 209.46 223 163.02 196.42"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M187.12,42.55h.03c.1-.08.21-.15.32-.21l-.35.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M311.46,103.98l-113.11-65.69c-1.6-.93-3.43-.68-4.72.31l-5.94,3.6c1.23-.67,2.78-.76,4.17.05l113.11,65.69c2.09,1.21,3.37,3.44,3.36,5.85l-.14,90.47c0,1.59-.84,2.88-2.03,3.6l6.24-3.78v-.03c1.32-.69,2.28-2.05,2.28-3.75l.14-90.47c0-2.41-1.28-4.64-3.36-5.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M308.19,204.27l.14-90.47c0-2.41-1.28-4.64-3.36-5.85l-113.11-65.69c-1.38-.8-2.94-.72-4.17-.05-.07.04-.14.09-.22.13-.11.07-.22.14-.32.22-.99.75-1.66,1.93-1.66,3.34l-.47,90.73c-.01,2.31,1.21,4.45,3.21,5.61l113.6,65.7c1.45.84,3.09.71,4.34-.06,1.18-.73,2.02-2.02,2.03-3.6Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "192.47 135.32 192.9 52.1 301.09 113.83 300.78 196.33 192.47 135.32"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M270.41,109.76c-19.36-4.01-25.81-17.79-25.81-17.79-11.63,3.72-25.7-8.26-25.7-8.26l-3.6,1.57s1.34,1.36,3.54,3.05c4.41,3.37,12.33,8.01,20.09,5.52,0,0,6.45,13.78,25.81,17.79,0,0,.29,15.81-10.52,29.07-4.12,5.04-8.01,8.26-10.9,10.22-2.95,2-4.85,2.7-4.85,2.7l5.67-1.89s7.43-2.72,15.74-12.92c10.81-13.26,10.52-29.07,10.52-29.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M254.22,140.72c10.81-13.26,10.52-29.07,10.52-29.07-19.36-4.01-25.81-17.79-25.81-17.79-7.76,2.48-15.67-2.16-20.09-5.52-2.2-1.68-3.54-3.05-3.54-3.05-1.63,43.25,23.17,68.34,23.17,68.34,0,0,1.9-.7,4.85-2.7,2.89-1.96,6.78-5.17,10.9-10.22ZM235.38,130.36l.08-10.62s-2.78-2.19-1.69-4.64,4.64-1.43,6.15.93c1.52,2.36,1.52,5.56-1.01,5.48v10.96l-3.54-2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M238.92,121.51c2.53.08,2.53-3.12,1.01-5.48-1.52-2.36-5.06-3.37-6.15-.93s1.69,4.64,1.69,4.64l-.08,10.62,3.54,2.11v-10.96Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M286.56,31.27c-1.08-13.55-9.72-24.03-19.3-23.41-1.11.07-2.19.3-3.22.65-1.78.5-4.32,1.59-5.7,2.21,1.2-.47,2.46-.77,3.77-.85,9.58-.62,18.23,9.96,19.32,23.63.97,12.15-4.37,22.64-12.29,25.26,4.76-1,7.67-2.48,9.35-3.63,6-3.77,8.93-13.15,8.08-23.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M263.89,59.67c-.13.02-.12.02,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M264.71,59.53c-.33.06-.56.09-.71.12.17-.03.42-.07.71-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M264.71,59.53c.25-.04.57-.09.95-.16h0c-.33.05-.65.11-.95.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M264,59.65s-.08.01-.11.02c.03,0,.07-.01.11-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M281.43,33.49c-1.09-13.67-9.73-24.25-19.32-23.63-1.31.08-2.57.38-3.77.85-7.55,2.98-12.55,13.22-11.62,25.02,1.07,13.48,9.5,23.95,18.92,23.64h0c.13,0,.26,0,.39-.01,1.07-.07,2.1-.28,3.09-.61,7.92-2.62,13.26-13.11,12.29-25.26ZM249.72,35.69c-.92-11.57,4.59-21.35,12.32-21.85s14.73,8.48,15.64,20.04c.92,11.57-4.59,21.35-12.32,21.85-7.72.5-14.73-8.48-15.64-20.04Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 263.7,
    cy: 34.79,
    rx: 14.01,
    ry: 21.01,
    transform: "translate(-2.07 24.16) rotate(-5.22)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M253.06,32.27c-.25,0-.45-.19-.46-.44,0-.18-.12-4.52,2.87-10.18,3.11-5.87,6.73-5.02,6.89-4.98.25.06.39.31.33.56-.06.24-.31.39-.55.33-.13-.03-3.11-.66-5.85,4.52-2.87,5.43-2.77,9.68-2.77,9.72,0,.25-.19.46-.44.47,0,0-.01,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M274.87,44.31s-.03,0-.05,0c-.25-.03-.43-.25-.41-.5,0-.07.76-7.45-.75-14.17-1.49-6.63-7.09-10.79-7.14-10.83-.2-.15-.25-.44-.1-.64.15-.2.43-.25.64-.1.24.18,5.93,4.4,7.5,11.37,1.54,6.87.77,14.39.77,14.47-.03.24-.22.41-.46.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M255.36,38.24c-.24,0-.44-.18-.46-.42-.94-10.97,2.78-14.49,2.93-14.63.19-.17.48-.16.65.03.17.19.16.48-.03.65-.04.04-3.54,3.43-2.64,13.88.02.25-.17.47-.42.5-.01,0-.03,0-.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M268.92,25.04c-.15,0-.3-.08-.39-.22-2.93-4.73-6.79-3.13-6.95-3.06-.23.1-.5,0-.6-.24-.1-.23,0-.5.24-.6.05-.02,4.74-2.01,8.1,3.41.13.22.07.5-.15.63-.07.05-.16.07-.24.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M259.14,32.88s-.08,0-.12-.02c-.24-.07-.39-.32-.32-.56.05-.19,1.36-4.76,4.3-4.42,2.81.32,3.93,2.6,3.98,2.7.11.23.01.5-.22.61s-.5.01-.61-.22c-.04-.08-.96-1.92-3.25-2.18-2.14-.25-3.3,3.71-3.31,3.75-.06.2-.24.34-.44.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M257.18,35.23c-.25,0-.46-.2-.46-.46,0-.25.02-6.09,2.97-8.93,1.1-1.06,2.46-1.56,4.06-1.5.25.01.45.22.44.48s-.22.45-.48.44c-1.33-.05-2.47.36-3.39,1.24-2.67,2.56-2.69,8.21-2.69,8.27,0,.25-.2.46-.46.46h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M254.4,44.94c-.18,0-.35-.11-.42-.29-1.08-2.64-1.54-8.4-1.56-8.65-.02-.25.17-.47.42-.49.25-.02.47.17.49.42,0,.06.48,5.86,1.5,8.37.1.23-.02.5-.25.6-.06.02-.12.03-.17.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M258.15,50.86s-.03,0-.05,0c-.25-.03-.43-.25-.41-.5,0-.07.68-6.6.31-12.97-.01-.25.18-.47.43-.48.25-.02.47.18.48.43.37,6.45-.31,13.06-.32,13.12-.03.24-.22.41-.46.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M270.81,36.32c-.22,0-.42-.16-.45-.39-.93-6.52-3.86-9.21-3.88-9.23-.19-.17-.21-.46-.04-.65.17-.19.46-.21.65-.04.13.12,3.2,2.9,4.18,9.79.04.25-.14.48-.39.52-.02,0-.04,0-.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M270.98,50.96c-.1,0-.2-.03-.29-.1-.2-.16-.23-.45-.07-.64,0,0,1.23-1.72,1.99-9.31.77-7.72-2.45-13.7-2.49-13.76-.12-.22-.04-.5.18-.62.22-.12.5-.04.62.18.14.25,3.39,6.28,2.59,14.29-.78,7.87-2.05,9.63-2.19,9.8-.09.11-.22.17-.36.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M267.38,41.5c-.24,0-.45-.19-.46-.44-.15-3.79-1.27-7.45-2.61-8.52-.27-.22-.52-.3-.76-.25-1.28.24-1.49,2.98-1.46,3.92,0,.25-.19.46-.44.47-.25,0-.46-.19-.47-.44-.01-.45-.08-4.43,2.21-4.85.5-.09,1.02.06,1.5.44,1.55,1.24,2.79,5.11,2.96,9.2.01.25-.19.47-.44.48,0,0-.01,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M261.68,53.33s-.09,0-.14-.02c-.24-.07-.38-.33-.3-.57,1.2-3.89-.18-13.34-.2-13.43-.04-.25.14-.48.39-.52.25-.04.48.14.52.39.06.4,1.43,9.75.17,13.84-.06.2-.24.32-.44.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M269.42,43.31s-.01,0-.02,0c-.25-.01-.45-.22-.44-.48.19-4.61-1.21-9.5-1.23-9.54-.07-.24.07-.5.31-.57.24-.07.5.07.57.31.06.2,1.46,5.07,1.26,9.84,0,.25-.21.44-.46.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M266.7,53.33c-.11,0-.23-.04-.31-.12-.18-.17-.19-.46-.02-.65,3.73-3.95,4.12-10.77,4.12-10.84.01-.25.22-.45.48-.43.25.01.45.23.43.48-.01.29-.4,7.22-4.37,11.42-.09.1-.21.14-.33.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M263.65,54.52s-.1,0-.15-.02c-.24-.08-.37-.34-.29-.58,0-.02.73-2.24,1-8.76.27-6.5-.61-9.07-.62-9.09-.08-.24.04-.5.28-.59.24-.09.5.04.58.27.04.11.95,2.73.67,9.44-.28,6.69-1.02,8.92-1.05,9.02-.07.19-.24.31-.43.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M266.97,48.89s-.09,0-.14-.02c-.24-.08-.37-.34-.3-.58.65-2.03.37-5.71.36-5.74-.02-.25.17-.47.42-.49.26-.02.47.17.49.42.01.16.3,3.9-.41,6.09-.06.19-.24.32-.44.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M256.55,48.71c-.23,0-.42-.17-.45-.4-.74-5.79-.92-8.55-.92-8.58-.02-.25.18-.47.43-.49.26-.01.47.18.49.43,0,.03.18,2.76.91,8.52.03.25-.15.48-.4.51-.02,0-.04,0-.06,0Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M145.46,55.38c-.52.07-1.15.35-1.81.66l-2.83,1.52h0c.26-.14.53-.24.82-.29,2.45-.42,4.94,2.68,5.57,6.94.49,3.29-.29,6.3-1.8,7.69l3.19-2.2c1.78-1.11,2.65-4.18,2.22-7.57-.51-4.06-2.91-7.08-5.37-6.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M144.55,72.5l.11-.08s-.07.03-.11.05v.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M166.83,36.11c-2.27-6.85-8.56-14.46-17.5-16.05-2.92-.52-5.7.09-8.14,1.19,0,0-5.7,2.75-9.8,8.62,2.65-3.16,7.99-8.27,14.22-7.2,8.35,1.42,14.43,9.27,16.74,16.4.67,2.06.41,4.58-.54,5.85l2.93-2.44.99-.83s.85-.81.89-.84c1.22-1.09.91-2.61.22-4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M148.24,37.73c-1.57-.4-3.16-.26-4.69.2,0,0-9.19,4.42-11.29,10.63.05-.09.08-.18.13-.27.23-.38,5.8-9.39,12.1-7.78,6.01,1.53,10.02,8.65,11.33,15.02.34,1.66.14,3.44-.43,4.69l2.82-2.62,1.28-1.18c1.41-1.33.7-2.31.27-4.49-1.23-6.17-5.11-12.54-11.54-14.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M147.23,64.2c-.63-4.25-3.13-7.36-5.57-6.94-.29.05-.56.15-.82.29-1.94,1.04-3.02,4.42-2.47,8.17.63,4.25,3.13,7.36,5.57,6.94.21-.04.42-.11.62-.19.04-.02.07-.03.11-.05.27-.13.53-.31.76-.53,1.51-1.39,2.29-4.4,1.8-7.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M155.83,55.53c-1.31-6.37-5.32-13.49-11.33-15.02-6.31-1.61-11.87,7.4-12.1,7.78-.05.08-.09.18-.13.27-.88,1.69-.94,4.41-.11,6.25.88,1.94,2.41,2.17,3.42.51.04-.07,4.21-6.7,8.32-5.65,4.29,1.09,6.79,6.08,7.43,9.17.34,1.64,1.1,2.71,1.95,2.93.39.1.8.02,1.19-.27.38-.28.69-.74.94-1.28.57-1.25.77-3.03.43-4.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M162.34,39.07c-2.32-7.14-8.39-14.98-16.74-16.4-6.23-1.06-11.57,4.05-14.22,7.2-1.05,1.26-1.68,2.21-1.76,2.34-.34.53-.57,1.23-.69,1.99h0c-.22,1.4-.06,3.02.5,4.29.87,1.97,2.36,2.35,3.34.85.06-.09,5.88-8.92,12.77-7.74,7.01,1.2,11.52,7.68,12.84,11.75.44,1.37,1.19,2.2,1.95,2.33.45.08.91-.09,1.31-.53.06-.07.11-.15.17-.23.96-1.27,1.21-3.8.54-5.85Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M88.13,197.61l-.22-28.68c0-1.28-.7-2.46-1.81-3.1l-26.74-15.45c-.84-.49-1.79-.42-2.52,0,0,0,0,0,0,0l-5.99,3.39.02.02c.75-.5,1.75-.62,2.65-.1l26.74,15.45c1.11.64,1.8,1.82,1.81,3.1l.22,28.68c.01,1.33-.68,2.43-1.66,3.06l5.14-2.94h-.01c1.35-.51,2.39-1.79,2.38-3.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M82.28,200.93l-.22-28.68c0-1.28-.7-2.46-1.81-3.1l-26.74-15.45c-.89-.52-1.9-.4-2.65.1-.65.44-1.12,1.17-1.12,2.07v30.59c0,1.3.69,2.49,1.82,3.14l13.93,7.98,7.34,10.05.02-5.84,4.02,2.3c1.26.72,2.69.58,3.76-.11.98-.63,1.67-1.73,1.66-3.06Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 55.99,
    cy: 174.45,
    rx: 2.63,
    ry: 5.46
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 64.94,
    cy: 179.92,
    rx: 2.63,
    ry: 5.46
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 75.01,
    cy: 184.99,
    rx: 2.63,
    ry: 5.46
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M359.01,228.2c-1.33-2.92-3.81-6.74-7.16-8.38-.68-.33-1.3-.51-1.87-.59-.66,1-.98,2.2-.96,3.41l.16,8.12,10.82,6.27.06-3.04c.03-1.78-.32-4.17-1.06-5.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M374.78,275.49l-.02-28.1c0-1.13-.6-2.17-1.58-2.74l-4.28-2.48-.04,1.91h-.02s-4.35,2.15-4.35,2.15l-4.59-2.99.12-6.22-10.82-6.27.03,1.61h0s-4.36,2.15-4.36,2.15l-4.94-2.76.05-5.17c-.13.08-.26.18-.37.29l-6.97,4.25.03.02c.58-.4,1.36-.49,2.05-.09l31.25,18.09c.98.57,1.58,1.61,1.58,2.74l.02,28.1c0,1.26-.71,2.27-1.68,2.79v.03s7.26-4.55,7.26-4.55c.95-.52,1.64-1.53,1.64-2.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M367.55,280l-.02-28.1c0-1.13-.6-2.17-1.58-2.74l-31.25-18.09c-.69-.4-1.47-.3-2.05.09-.49.34-.83.88-.84,1.56l-.17,29.23c0,1.11.57,2.14,1.52,2.72l29.57,18.03c1.03.63,2.21.58,3.14.09.97-.52,1.68-1.53,1.68-2.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M349.98,219.24c-1.61-.21-2.82.46-3.68,1.3-1.12,1.11-1.68,2.68-1.65,4.25l.2,9.72,4.36-2.15h0s-.03-1.6-.03-1.6l-.16-8.12c-.02-1.21.3-2.41.96-3.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M350.09,213.65c7.22,1.04,12.74,8.24,14.45,16.13.2.91.27,1.85.25,2.78l-.32,13.67,4.35-2.16h.02s.04-1.89.04-1.89l.27-11.76c.02-.93-.05-1.87-.25-2.78-1.71-7.89-7.23-15.09-14.45-16.13-1.87-.27-3.48.09-4.83.75-2.89,1.09-4.96,2.43-5.33,2.68,1.53-.97,3.45-1.61,5.79-1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M339.91,231.76l4.94,2.76-.2-9.72c-.03-1.58.52-3.14,1.65-4.25.86-.85,2.07-1.52,3.68-1.3.57.08,1.19.26,1.87.59,3.35,1.64,5.83,5.46,7.16,8.38.74,1.62,1.09,4.01,1.06,5.79l-.06,3.04-.12,6.22,4.59,2.99.32-13.67c.02-.93-.05-1.87-.25-2.78-1.71-7.89-7.23-15.09-14.45-16.13-2.33-.34-4.26.3-5.79,1.27-.54.34-1.03.73-1.47,1.12-1.81,1.65-2.82,4.01-2.84,6.46l-.04,4.09-.05,5.17Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M346.81,254.42s-3.04-2.4-1.84-5.07c1.2-2.67,5.07-1.57,6.73,1.01,1.66,2.58,1.66,6.08-1.11,5.99v11.98l-3.87-2.3.09-11.61Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityTestingGraphicRight);
export default __webpack_public_path__ + "static/media/Security-testing-graphic-right.8274fe9d334bf8da238b9e9ab6c544fe.svg";
export { ForwardRef as ReactComponent };